module.exports = __webpack_public_path__ + "images/emoji/clock5.ded54bff793c6c3e6e7a.png";